import { setShowEditOrderItemModal } from '../State/showEditOrderItemModal';
import { setSelectedOrderItemKeys } from '../State/selectedOrderItemKeys';

export default () => async (dispatch) => {

  dispatch(setShowEditOrderItemModal(false));
  dispatch(setSelectedOrderItemKeys(null));
  
}